import DOMPurify from 'dompurify';

// Configure DOMPurify to strip dangerous attributes but not remove them outright
DOMPurify.setConfig({
    ALLOWED_ATTR: [], // Disallow all attributes by default
    RETURN_TRUSTED_TYPE: true,
    RETURN_DOM: false
});


function isValidURL(url) {
    // Define the regular expression pattern to match a valid URL
    const urlPattern = new RegExp(
        '^(https?:\\/\\/)?' + // Protocol (optional)
        '((([a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,})|' + // Domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR IPv4 address
        '(\\:\\d+)?' + // Port (optional)
        '(\\/[-a-zA-Z0-9@:%_\\+.~#?&//=]*)?' + // Path (optional)
        '(\\?[;&a-zA-Z0-9%_\\+.~#?&//=]*)?' + // Query string (optional)
        '(\\#[-a-zA-Z0-9_]*)?$', // Fragment identifier (optional)
        'i'
    );

    // Test the URL against the pattern
    return !!urlPattern.test(url);
}

function isXSSAttempt(data) {
    if (typeof data === 'string') {
        // Purify the data
        const sanitized = DOMPurify.sanitize(data);
        //URL
        if(data && isValidURL(data)) {
            
            return false
        }

        //If both are empty, it is just an empty string not XSS
        if(sanitized == "" && data == "") {
            return false;
        }

        // Compare sanitized with original
        if (sanitized.toString() !== data) {
            return true; // XSS detected if there are differences
        }

        // Additional checks for common XSS patterns not caught by DOMPurify
        const xssPatterns = [
            /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,
            /javascript:/gi,
            /on\w+\s*=\s*["'].*["']/gi, // Event handlers like onerror, onclick, etc.
            /<img\s+[^>]*src\s*=\s*["']?javascript:/gi, // Image tags with JavaScript
            /<iframe\b[^<]*(?:(?!<\/iframe>)<[^<]*)*<\/iframe>/gi
        ];

        for (let pattern of xssPatterns) {
            if (pattern.test(data)) {
                return true; // XSS pattern detected
            }
        }
    } else if (typeof data === 'object' && data !== null) {
        for (let key in data) {
            if (data.hasOwnProperty(key)) {
                if (isXSSAttempt(data[key])) {
                    
                    return true; // XSS detected in any string property
                }
            }
        }
    }
    return false; // No XSS detected
}



export default isXSSAttempt;
